import React from 'react';

const About: React.FC = () => {
  return (
    <>
      {/* Hero — editorial statement */}
      <section className="about-hero about-hero-editorial">
        <div className="about-hero-content">
          <p className="about-kicker">About VoyCalc</p>
          <h1 className="about-statement">
            Built by shipping professionals,
            <br />
            for <span className="hero-highlight">shipping professionals</span>.
          </h1>
        </div>
      </section>

      {/* Mission — editorial prose */}
      <section className="about-story">
        <div className="about-story-container">
          <div className="about-story-grid">
            <p className="about-story-label">Our Mission</p>
            <div>
              <p className="about-lede">
                VoyCalc was born from a simple observation:{' '}
                <span className="about-highlight">commercial shipping decisions deserve better tools</span>.
                We set out to create a voyage calculator that's powerful enough for complex
                estimates, yet simple enough to use on the go.
              </p>
              <p className="about-prose">
                Built with guidance from industry veterans, VoyCalc combines decades of maritime
                expertise with modern technology to give you the edge in today's competitive
                market.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pull quote */}
      <section className="about-quote">
        <p className="about-quote-main">We're not a VMS.</p>
        <p className="about-quote-sub">
          We do <span className="about-highlight">one thing</span> exceptionally well: Voyage
          Calculations.
        </p>
      </section>

      {/* Principles — numbered manifesto */}
      <section className="about-principles-section">
        <div className="about-story-container">
          <p className="about-story-label">What We Stand For</p>
          <div className="about-principles">
            <div className="about-principle">
              <span className="about-principle-num">01</span>
              <h3 className="about-principle-title">Independent</h3>
              <p className="about-principle-text">
                We're not owned by any shipping company, venture capital, or private equity firm.
                This independence means our only focus is building the best tool for you.
              </p>
            </div>
            <div className="about-principle">
              <span className="about-principle-num">02</span>
              <h3 className="about-principle-title">Focused</h3>
              <p className="about-principle-text">
                All the power of enterprise tools, none of the complexity. Every feature earns its
                place in the estimate — or it doesn't ship.
              </p>
            </div>
            <div className="about-principle">
              <span className="about-principle-num">03</span>
              <h3 className="about-principle-title">Mobile-First</h3>
              <p className="about-principle-text">
                Make decisions anywhere. VoyCalc is designed to work seamlessly across all your
                devices, from desktop to smartphone.
              </p>
            </div>
            <div className="about-principle">
              <span className="about-principle-num">04</span>
              <h3 className="about-principle-title">Lightning Fast</h3>
              <p className="about-principle-text">
                Re-use your data efficiently. Create accurate voyage estimates in minutes, not
                hours. Speed matters when opportunities arise.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="about-cta">
            <p className="about-cta-text">Ready to streamline your voyage calculations?</p>
            <a href="/?page=enterprise" className="btn-about-cta">
              Get Started
              <i className="bi bi-arrow-right ms-2"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
